export default __webpack_public_path__ + "static/media/grn.6326e40d.png";